var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlowSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 41.35 42.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-4{fill:none;}.cls-2{font-size:24.93px;fill:#442c5c;font-family:MyriadPro-Regular, Myriad Pro;}.cls-3{clip-path:url(#clip-path);}.cls-4{stroke:#442c5c;stroke-miterlimit:10;stroke-width:1.96px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 41.35,
    height: 42.42
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 56") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(14.7 31.29) scale(1.18 1)"
  }, "?"), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M39.71,29.14l-1.29-.79a18.82,18.82,0,0,0,1-6.08A19,19,0,0,0,32.71,7.74c-2-1.76-4.86.15-3,2.5a15.25,15.25,0,0,1,5.87,12,15.43,15.43,0,0,1-.57,4.1l-1.7-1c-.89-.52-1.59-.09-1.58,1l.12,7.2c0,1,.75,1.49,1.64,1L39.7,31A1,1,0,0,0,39.71,29.14ZM18,10.75,24.26,7a1.06,1.06,0,0,0,0-2L17.92,1.22c-.91-.54-1.65-.13-1.64.93l0,7.67C16.31,10.87,17.06,11.29,18,10.75ZM4.83,20.2A15.35,15.35,0,0,1,16.27,7.44v-4a19.27,19.27,0,0,0-15,15C-.14,23.23,4.69,22.27,4.83,20.2Zm21,16.3A15.4,15.4,0,0,1,9.51,33.37l1.26-.75a1,1,0,0,0,0-1.86L4.57,27.29a1,1,0,0,0-1.67,1l-.15,7.22c0,1,.69,1.46,1.58.94l1.75-1a19.28,19.28,0,0,0,14.05,6.06,19,19,0,0,0,5.77-.89C29.78,39.53,27.85,35.69,25.86,36.5Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowSwitch);
export default __webpack_public_path__ + "static/media/flowSwitch.bd6818d954b3908d732cc52e34e7a38a.svg";
export { ForwardRef as ReactComponent };